module.exports = __webpack_public_path__ + "static/img/goods-400.3007452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/goods-400.png
// module id = QLqe
// module chunks = 2